// src/components/AssetCard.js
import React from 'react';
import RichViewToggleButton from './advanced_asset/RichViewToggleButton';

export default function AssetCard({ asset }) {
  const {
    asset_name,
    asset_ext_id,
    asset_make,
    asset_model,
    street_address = '',
    city = '',
  } = asset || {};

  const name = asset_name?.trim() || 'Unnamed Asset';

  const extIdPresent = Boolean(asset_ext_id != null && String(asset_ext_id).trim());

  const locationLine =
    (street_address && String(street_address).trim()) || (city && String(city).trim())
      ? [street_address, city].map((s) => (s || '').trim()).filter(Boolean).join(', ')
      : 'Unknown Location';

  const makePart = (asset_make || '').trim();
  const modelPart = (asset_model || '').trim();
  const makeModelLine =
    makePart && modelPart
      ? `${makePart} / ${modelPart}`
      : makePart || modelPart || null;

  return (
    <>
      <div className="card mb-3 shadow-sm border-0">
        <div className="card-body d-flex">
          <div className="text-primary me-3" style={{ fontSize: '2rem' }}>
            <i className="bi bi-lightning-charge-fill" aria-hidden />
          </div>
          <div className="flex-grow-1 min-w-0">
            <h5 className="card-title mb-2">{name}</h5>
            {extIdPresent && (
              <div className="small mb-1">
                <span className="text-muted">Ext ID</span>{' '}
                <span className="font-monospace text-body">{String(asset_ext_id).trim()}</span>
              </div>
            )}
            <div className="small text-muted d-flex align-items-start gap-1 mb-1">
              <i className="bi bi-geo-alt mt-0 flex-shrink-0" aria-hidden />
              <span>{locationLine}</span>
            </div>
            {makeModelLine && (
              <div className="small text-muted">{makeModelLine}</div>
            )}
          </div>
        </div>
      </div>
      <RichViewToggleButton hasIntegration={asset?.has_iot_integration} />
    </>
  );
}
